import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box, Card, Flex, Link, Text, Badge } from 'pcln-design-system';
import { ChevronRight } from 'pcln-icons';
import PriceWatch from './PriceWatchBanner';
const MAX_MEDIA_SIZE = 72;
const StyledCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "RecentSearchCard__StyledCard",
  componentId: "sc-o7p2gv-0"
})(["border:none;box-shadow:", ";cursor:pointer;&:hover{box-shadow:", ";}"], themeGet('shadows.sm'), props => themeGet(`shadows.${props.hoverBoxShadowSize || 'xl'}`));
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "RecentSearchCard__StyledFlex",
  componentId: "sc-o7p2gv-1"
})(["display:flex;flex-direction:row;align-items:center;"]);
const Heading = /*#__PURE__*/styled(Text).withConfig({
  displayName: "RecentSearchCard__Heading",
  componentId: "sc-o7p2gv-2"
})(["", ""], props => props.width && `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `);
/** @public */
function RecentSearchCard({
  className,
  actionText,
  heading,
  headingWidth,
  headingTextTransform = 'none',
  icon,
  isIconRounded = true,
  isPriceWatch = false,
  overline,
  handleSubmitCTA,
  onClick,
  hoverBoxShadowSize,
  priceWatch
}) {
  const iconColor = icon && icon.props.color || 'primary';
  const iconBgColor = iconColor && `${iconColor.split('.')[0]}.light`;
  const iconSize = isIconRounded ? 24 : 32;
  const iconWrapperSize = isIconRounded ? 48 : MAX_MEDIA_SIZE;
  const iconWrapperRadius = isIconRounded ? 'full' : 'xl';
  function handleKeyDown(e) {
    if (handleSubmitCTA && e.key === 'Enter') {
      handleSubmitCTA(e);
    }
  }
  return React.createElement(StyledCard, {
    "data-testid": 'recent-search-card',
    borderRadius: 'xl',
    className: className,
    color: 'background.lightest',
    hoverBoxShadowSize: hoverBoxShadowSize,
    minHeight: MAX_MEDIA_SIZE,
    p: 3,
    role: 'link',
    tabIndex: '0',
    onClick: onClick,
    onKeyDown: handleKeyDown
  }, React.createElement(StyledFlex, null, React.createElement(Box, null, React.createElement(Flex, {
    alignItems: 'center',
    borderRadius: iconWrapperRadius,
    color: iconBgColor,
    justifyContent: 'center',
    height: iconWrapperSize,
    width: iconWrapperSize,
    mr: 1
  }, React.cloneElement(icon, {
    color: iconColor,
    size: iconSize
  }))), React.createElement(Flex, {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  }, React.createElement(Flex, {
    flexDirection: 'column',
    mx: 2
  }, isPriceWatch ? React.createElement(Badge, {
    bg: 'primary.light',
    color: 'primary',
    textTransform: 'none',
    size: 'captionSmall',
    style: {
      width: 'max-content'
    },
    mb: 1
  }, React.createElement(Text, {
    textStyle: 'caption'
  }, "Price Watch")) : React.createElement(Text, {
    color: 'text.light',
    textStyle: 'caption',
    mb: 1
  }, overline), React.createElement(Heading, {
    fontWeight: 'bold',
    textStyle: 'heading6',
    textTransform: headingTextTransform,
    width: headingWidth
  }, heading), actionText && React.createElement(Link, {
    onClick: onClick,
    mt: 1
  }, React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Text, {
    textStyle: 'caption'
  }, actionText), React.createElement(ChevronRight, {
    width: 20,
    height: 20,
    ml: 2
  })))))), isPriceWatch && React.createElement(PriceWatch, {
    savingsPercentage: priceWatch.savingsPercentage,
    dealPrice: priceWatch.dealPrice
  }));
}
export default RecentSearchCard;